<template>
  <div v-if="nickname" class="box" :style="`${width && nicknameOverflow ? `width: ${width};` : ''}${isCenter ? 'justify-content: center' : ''}`">
    <div class="avatar-box" :style="isCenter ? 'justify-content: flex-end;width: 50%;' : ''">
      <router-link
        v-if="linkPageName"
        :to="{ name: linkPageName, params: { id: linkPageId }, query: linkPageQuery  }"
      >
        <v-avatar v-model="value" :size="avatarSize"/>
      </router-link>
      <v-avatar v-else v-model="value" :size="avatarSize"/>
    </div>
    <div v-if="linkPageName" :class="`name${nicknameOverflow ? ' name-box' : ''}`">
      <router-link
        :to="{ name: linkPageName, params: { id: linkPageId }, query: linkPageQuery  }"
        class="primary-color"
        :title="nickname"
      >
        {{ nickname }}
      </router-link>
    </div>
    <div v-else :class="`name${nicknameOverflow ? ' name-box' : ''}`" :title="nickname">{{ nickname }}</div>
  </div>
  <div class="empty-box" :style="`${width ? `width: ${width}` : ''}`" v-else>{{ emptyString }}</div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    nickname: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '128px',
    },
    avatarSize: {
      type: Number,
      default: 50,
    },
    nicknameOverflow: Boolean,
    isCenter: Boolean,
    linkPageName: {
      type: String,
      default: '',
    },
    linkPageId: {
      type: Number,
      default: 0,
    },
    linkPageQuery: {
      type: Object,
      default: () => {},
    },
    emptyString: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  align-items: center;
}

.empty-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
}

.avatar-box {
  display: flex;
  padding-right: 4px;
}

.name {
  box-sizing: border-box;
  padding-left: 4px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name-box {
  width: 50%;
}
</style>
